import React from "react";
import { Col, Container, Row } from "react-bootstrap";

// The caller owns field mapping and every business action. CSS owns all geometry.
export default function CourseHero({ titleLeft, title = "", summary, slogan, mediaSrc, fallbackSrc, cta }) {
    const words = title.trim().split(/\s+/);
    const heading = <h1 className="course-hero__title montserrat-alternates-bold">
        <span className="title course-hero__title-first">{words[0]}</span>{" "}
        {words.length > 1 && <span className="sub-title course-hero__title-rest">{words.slice(1).join(" ")}</span>}
    </h1>;
    const renderSlogan = className => slogan?.trim() ? <div className={`course-hero__slogan green-text ${className}`} dangerouslySetInnerHTML={{ __html: slogan }} /> : null;
    const summaryRegion = summary?.trim() ? <div className="course-hero__summary info-texts mt-4">
        {titleLeft ? summary.trim().split(/\s+/).map((word, index) => <span className="course-hero__summary-line" key={index}>{word}</span>) : summary}
    </div> : null;
    const artwork = <div className={`course-hero__art ${titleLeft ? "super-detka-cat" : "mama-dai-cat"}`}>
        <img src={mediaSrc || fallbackSrc} alt={title || "course-gif"} onError={event => {
            if (event.currentTarget.getAttribute("src") !== fallbackSrc) event.currentTarget.src = fallbackSrc;
        }} />
    </div>;

    return <section className={`course-hero course-hero--title-${titleLeft ? "left" : "right"}`}>
        <Container className="first-block">
            {titleLeft ? <>
                <div className="title-block">
                    {heading}
                    {renderSlogan("mt-4 d-none d-lg-block")}
                </div>
                {summaryRegion}
                {artwork}
            </> : <Row className="hero-row">
                <Col lg={6} className="media-column order-2 order-lg-1">
                    {renderSlogan("mt-4 d-none d-lg-block")}
                    {artwork}
                </Col>
                <Col lg={6} className="order-1 order-lg-2 course-hero__copy">
                    <div className="title-block">{heading}</div>
                    {summaryRegion}
                </Col>
            </Row>}
        </Container>
        {renderSlogan("d-block d-lg-none text-center")}
        <Container>
            <div className="course-hero__cta price-block">
                <div className="price-button-block position-relative gap-4">{cta}</div>
            </div>
        </Container>
        <div className="course-hero__wave uneven-edge-block" aria-hidden="true"><div className="layer" /></div>
    </section>;
}
